const baseUrl = "https://api.telegram.org/bot7081147575:AAFAEPVhO0lxHHeszmgeHtPMmoD8hB4J8dk/";

export const sendMessage = async (message: string): Promise<void> => {
  const url: string = `${baseUrl}sendMessage?chat_id=-1002192778633&text=${message}`;

  console.log(message);
  const response: Response = await fetch(url);

  console.log("response", response);
};
